import React from "react";
import Lottie from "react-lottie";
import loading from "assets/animations/loading.json";

const LoadingSpin = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loading,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="absolute flex flex-col items-center justify-center gap-4 w-full bg-white h-screen ">
      <Lottie options={defaultOptions} height={200} width={280} />
      <p className=" text-2xl md:text-4xl font-bold">
        <span className=" text-primary">PIONE</span>{" "}
        <span className=" text-primary-orange">CARE</span>
      </p>
    </div>
  );
};

export default LoadingSpin;
